import { withStyles } from '../../tools/withStyles';
import { withAnimation } from '../../tools/withAnimation';
import { withSounds } from '../../tools/withSounds';
import { withLanguage } from '../../tools/withLanguage';
import { Component } from './Menu';
import { styles } from './Menu.styles';

const Menu = withAnimation()(withStyles(styles)(withSounds()(withLanguage()(Component))));

export { Menu };
